import React, { Fragment } from "react";
import styled from "styled-components";
import intl from "react-intl-universal";
import { useInput } from "../../../../../hooks/useInput";

import { Grid } from "../../../../../components/Grid";
import { Output } from "../../../../../components/Output";
import { Spacer } from "../../../../../components/Spacer";
import { ScrollBox } from "../../../../../components/ScrollBox";
import { Spinner } from "../../../../../components/Spinner";
import { useOnChange } from "../../../../../hooks/useOnChange";

const WorstcaseDetailStyle = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    font-size: 11px;
    >div:nth-child(3) {
        >div {
            grid-row-gap: 6px;
        }
    }
`;

export const WorstcaseDetail = props => {

    const { detail, areaName, calcSetting, disabled } = props;

    const { imageSetting, sliceNum } = calcSetting;
    const slice = useInput("slice", imageSetting.slice);

    useOnChange((name, value, ignore) => {
        if (ignore !== true) {
            onChange(name, value);
        }
    }, [slice]);

    const onChange = (name, value) => {
        imageSetting[name] = value;
        props.onChange(imageSetting);
    };

    return (
        <WorstcaseDetailStyle>
            <Spacer variant="horizontal" />
            <Grid columns="2">
                <Grid template="1fr 3.35fr">
                    <Output value={intl.get("entry.plan.worstcase.name")} />
                    <Output value={areaName} />
                </Grid>
                <Spinner {...slice.bind}
                    disabled={disabled}
                    min={0}
                    max={(sliceNum - 1)}
                    step={1}
                    title={intl.get("entry.plan.wattwaechter.slice")} />
            </Grid>
            <Spacer variant="horizontal" />
            <ScrollBox>
                <Grid columns="4">
                    <Output value={intl.get("entry.plan.worstcase.positionX")} />
                    <Output value={detail[0].x.toFixed(2)} />
                    <Output value={intl.get("entry.plan.worstcase.positionY")} />
                    <Output value={detail[0].y.toFixed(2)} />
                    <div /><div /><div /><div />
                    {detail.map((item, index) =>
                        <Fragment key={index}>
                            <Output value={intl.get("entry.plan.worstcase.radio")} />
                            <Output value={item.column + 1} />
                            <Output value={intl.get("entry.plan.worstcase.systemName")} />
                            <Output value={item.systemName} />
                            <Output value={intl.get("entry.plan.worstcase.antennaFrequency")} />
                            <Output value={item.frequency} />
                            <Output value={intl.get("entry.plan.worstcase.antennaElecDowntilt")} />
                            <Output value={item.downtilt} />
                            <Output value={intl.get("entry.plan.worstcase.antennaPort")} />
                            <Output value={item.port} />
                            <Output value={intl.get("entry.plan.worstcase.field")} />
                            <Output value={item.field.toFixed(4)} />
                            <div />
                            <div />
                            <div />
                            <div />
                        </Fragment>
                    )}
                </Grid>
            </ScrollBox>
        </WorstcaseDetailStyle>
    );
};
